function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import angular from 'angular';
import { keyBy } from 'lodash';
import { AccesoDatos } from 'src/_candidato/comun/services/acceso-datos';
var PanelIntroComponentCtrl = /*#__PURE__*/function () {
  PanelIntroComponentCtrl.$inject = ["$timeout", "$log", "NotifService", "AccesoDatos"];
  function PanelIntroComponentCtrl($timeout, $log, NotifService, AccesoDatos) {
    _classCallCheck(this, PanelIntroComponentCtrl);
    _defineProperty(this, "$loading", false);
    _defineProperty(this, "$ready", false);
    _defineProperty(this, "textos", null);
    _defineProperty(this, "textosIntro", {});
    this.$timeout = $timeout;
    this.$log = $log;
    this.NotifService = NotifService;
    this.AccesoDatos = AccesoDatos;
  }
  return _createClass(PanelIntroComponentCtrl, [{
    key: "$onInit",
    value: function $onInit() {
      this.$log.info('[PanelIntroComponentCtrl] onInit');
    }
  }, {
    key: "$postLink",
    value: function $postLink() {
      // para dar tiempo a inicializarse materialize
      this._leerTextos();
    }
  }, {
    key: "_leerTextos",
    value: function _leerTextos() {
      var _this = this;
      this.$loading = true;
      this.AccesoDatos.GestionTextos_CLIENT.textos().then(function (textosResponse) {
        _this.textos = textosResponse;
        _this.textosIntro = _this._initTextos('INTRO', _this.textos.porKey.INTRO || []);
        _this.$loading = false;
        _this.$timeout(function () {
          return _this.$ready = true;
        }, 100);
      });
    }
  }, {
    key: "_initTextos",
    value: function _initTextos(key, textos) {
      function initLang(_textosLang, textlng) {
        if (!_textosLang[textlng]) {
          _textosLang[textlng] = {
            textkey: key,
            text: '',
            textlng: textlng
          };
        }
      }

      // buscar el registro para es y para en
      var textosLang = keyBy(textos, function (t) {
        return t.textlng;
      }) || {};

      // asegurar inicialización para es y para en
      initLang(textosLang, 'es');
      initLang(textosLang, 'en');
      return textosLang;
    }
  }, {
    key: "saveTextosIntro",
    value: function saveTextosIntro() {
      var _this2 = this;
      if (this.$loading) return;
      var dto = {
        registros: [this.textosIntro['es'], this.textosIntro['en']]
      };
      this.$loading = true;
      this.AccesoDatos.GestionTextos_CLIENT.actualizaTextos(dto).then(function (textosResponse) {
        // actualizar los textos si ya estaban guardados
        _this2.textosIntro = _this2._initTextos('INTRO', textosResponse || []);
        _this2.$loading = false;
      });
    }
  }]);
}();
angular.module('candidato').component('panelIntro', {
  bindings: {
    // empresa: "<",
  },
  controller: PanelIntroComponentCtrl,
  // templateUrl: "panel-intro.component.html",
  template: require('./panel-intro.component.html')
});